import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantResidenceRelationshipPage = {
  footer: {
    root: 'coapplicant-residence-relationship-page.footer.root',
  },
  form: {
    h1: 'coapplicant-residence-relationship-page.form.h1',
    h2: 'coapplicant-residence-relationship-page.form.h2',
    radioGroupRoot:
      'coapplicant-residence-relationship-page.form.radio-group-root',
    radioOption1: 'coapplicant-residence-relationship-page.form.radio-option1',
    radioOption2: 'coapplicant-residence-relationship-page.form.radio-option2',
    root: 'coapplicant-residence-relationship-page.form.root',
    submitButton: 'coapplicant-residence-relationship-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
